export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Bluetooth</title>
    <path
      d="m10 22.611 13-11.555L16.5 6v20.222l6.5-5.055-13-10.111"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
